// Pure helpers for the admin "Where people come from" card (components/TrafficSourcesCard.js).

export const ALL_WEEKS = 'all';

// Rows from GET /api/admin/analytics/traffic-sources -> one row per source/medium/campaign for
// the chosen week (or every week merged), busiest first.
export function summarizeTrafficRows(rows, week) {
  const picked = (rows || []).filter((r) => week === ALL_WEEKS || r.week_start === week);
  const merged = {};
  picked.forEach((r) => {
    const key = `${r.source}|${r.medium || ''}|${r.campaign || ''}`;
    if (!merged[key]) {
      merged[key] = { key, source: r.source, medium: r.medium, campaign: r.campaign,
        signups_seekers: 0, signups_employers: 0, apply_intents: 0, applications: 0, applicants: 0 };
    }
    const m = merged[key];
    m.signups_seekers += r.signups_seekers || 0;
    m.signups_employers += r.signups_employers || 0;
    m.apply_intents += r.apply_intents || 0;
    m.applications += r.applications || 0;
    // Summed across weeks: someone who applied in two weeks counts twice in "All weeks".
    m.applicants += r.applicants || 0;
  });
  return Object.values(merged).sort((a, b) =>
    (b.applications - a.applications) || (b.signups_seekers - a.signups_seekers) || (b.apply_intents - a.apply_intents));
}
